import Cookies from "js-cookie";
import API from "../../utils/endpoints";
import * as types from "./actionType";
import history from "../../history";
import axios from "axios"; 
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getAuthenticationCookie,
  setAuthenticationCookie,
} from "../../utils/authentication"; 

const errorMessage = {
  status: 400,
  message: "Something went wrong",
};

function loggingUser() {
  return {
    type: types.LOGIN_USER,
  };
}

function loggingUserSuccess(payload) {
  return {
    type: types.LOGIN_USER_SUCCESS,
    payload,
  };
}

function loggingUserFailed(payload) {
  return {
    type: types.LOGIN_USER_FAILED,
    payload,
  };
}

function fetchingUserPermissions() {
  return {
    type: types.FETCH_USER_PERMISSIONS,
  };
}

function fetchingUserPermissionsSuccess(payload, user) {
  return {
    type: types.FETCH_USER_PERMISSIONS_SUCCESS,
    payload,
    user,
  };
}

function fetchingUserPermissionsFailed(payload) {
  return {
    type: types.FETCH_USER_PERMISSIONS_FAILED,
    payload,
  };
}

function fetchingCurrentUserProfile() {
  return {
    type: types.FETCH_CURRENT_USER_PROFILE,
  };
}

function fetchingCurrentUserProfileSuccess(payload) {
  return {
    type: types.FETCH_CURRENT_USER_PROFILE_SUCCESS,
    payload,
  };
}

function fetchingCurrentUserProfileFailed(payload) {
  return {
    type: types.FETCH_CURRENT_USER_PROFILE_FAILED,
    payload,
  };
}

export function authenticateUser(payload) {
  return {
    type: types.AUTHENTICATE_USER,
    payload,
  };
}

//****** Reset Password   ********//

export function resettingPassword() {
  return {
    type: types.RESET_PASSWORD,
  };
}

export function resettingPasswordSuccess() {
  return {
    type: types.RESET_PASSWORD_SUCCESS,
  };
}

export function resettingPasswordFailed() {
  return {
    type: types.RESET_PASSWORD_FAILED,
  };
}

export function handlePageLoading(payload) {
  return {
    type: types.HANDLE_PAGE_LOADING,
    payload,
  };
}

//****** Forgot Password   ********//

export function forgotpassword() {
  return {
    type: types.FORGOT_PASSWORD,
  };
}

export function forgotPasswordSuccess(payload) {
  return {
    type: types.FORGOT_PASSWORD_SUCCESS,
    payload,
  };
}

export function forgotPasswordFailed() {
  return {
    type: types.FORGOT_PASSWORD_FAILED,
  };
}

//****** OTP VARIFICATION   ********//

export function otpverification() {
  return {
    type: types.OTP_VARIFICATION,
  };
}

export function otpverificationSuccess() {
  return {
    type: types.OTP_VARIFICATION_SUCCESS,
  };
}

export function otpverificationFailed() {
  return {
    type: types.OTP_VARIFICATION_FAILED,
  };
}

//****** SET NEW PASSWORD   ********//

export function settingNewPassword() {
  return {
    type: types.SET_NEW_PASSWORD,
  };
}

export function settingNewPasswordSuccess() {
  return {
    type: types.SET_NEW_PASSWORD_SUCCESS,
  };
}

export function settingNewPasswordFailed() {
  return {
    type: types.SET_NEW_PASSWORD_FAILED,
  };
}

//****** Verify Token   ********//

export function validatingToken() {
  const { guid } = getAuthenticationCookie();
  return {
    type: types.VERIFY_TOKEN,
    payload: guid,
  };
}

export function validatingTokenSuccess(payload) {
  return {
    type: types.VERIFY_TOKEN_SUCCESS,
    payload: payload,
  };
}

export function validatingTokenFailed(payload) {
  return {
    type: types.VERIFY_TOKEN_FAILED,
  };
}

//****** Generate Token   ********//

export function generatingToken() {
  return { type: types.GENERATE_TOKEN };
}

export function generatingTokenSuccess(payload) {
  return {
    type: types.GENERATE_TOKEN_SUCCESS,
    payload: payload,
  };
}

export function generatingTokenFailed(payload) {
  return {
    type: types.GENERATE_TOKEN_FAILED,
  };
}

//****** logging out user  ********//

export function loggingoutUser() {
  return {
    type: types.LOGOUT_USER,
  };
}

export function loggingoutUserSuccess() {
  return {
    type: types.LOGOUT_USER_SUCCESS,
  };
}

export function loggingoutUserFailed(payload) {
  return {
    type: types.LOGOUT_USER_FAILED,
  };
}

//****** logging out user  ********//

export function gettingLoggedInUserData() {
  return {
    type: types.GET_LOGIN_USERDATA,
  };
}

export function gettingLoggedInUserDataSuccess(payload) {
  return {
    type: types.GET_LOGIN_USERDATA_SUCCESS,
    payload,
  };
}

export function gettingLoggedInUserDataFailed(payload) {
  return {
    type: types.GET_LOGIN_USERDATA_FAILED,
  };
}

//****** LOGIN  ********//

export const loginUser = (payload) => async (dispatch, getState, api) => {
  dispatch(loggingUser());

  try {
    const formattedValue = `${payload.username}:${payload.password}`;
    const encryptedValue = await encryptString(formattedValue);
    // let response = await api.post(API.login, { credentials: encryptedValue });

    axios
      .post(`${API.baseUrl}${API.login}`, { credentials: encryptedValue })
      .then((response) => {
        if (response.data.code === 200) {
          setAuthenticationCookie(response.data.data);
          dispatch(loggingUserSuccess(response.data.data));
          history.push("/");
        } else {
          toast.error(response.data.message);
          dispatch(loggingUserFailed(response.data));
          Cookies.remove("RE_BU_CR");
        }
      })
      .catch((error) => {
        dispatch(loggingUserFailed(error));
        toast.error(errorMessage);
      });
  } catch (error) {
    dispatch(loggingUserFailed(errorMessage));
    toast.error(errorMessage);
  }
};

//****** USER DATA  ********//

export const getLoggedInUserData = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(gettingLoggedInUserData());
  try {
    let response = await api.get(API.getLoggedInUserData);

    if (response.data.code === 200) {
      dispatch(gettingLoggedInUserDataSuccess(response.data.data));
    } else {
      dispatch(gettingLoggedInUserDataFailed(response.data));
    }
  } catch (error) {
    dispatch(gettingLoggedInUserDataFailed(errorMessage));
  }
};

//****** Fetch User Permission  ********//

export const fetchUserPermissions = () => async (dispatch, getState, api) => {
  dispatch(fetchingUserPermissions());
  try {
    let response = await api.get(API.getUserPermissions);
    if (response.data.code === 200) {
      dispatch(
        fetchingUserPermissionsSuccess(
          response.data.data.pageGroups,
          response.data.data
        )
      );
    } else {
      dispatch(fetchingUserPermissionsFailed(response.data));
    }
  } catch (error) {
    dispatch(fetchingUserPermissionsFailed(errorMessage));
  }
};

//****** Fetch User Profile  ********//

export const fetchCurrentUserProfile = () => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingCurrentUserProfile());
  try {
    let response = await api.get(API.getUserProfile);
    if (response.data.code === 200) {
      dispatch(fetchingCurrentUserProfileSuccess(response.data.data));
      localStorage.setItem("accessCountries" , JSON.stringify(response.data.data.accessibleCountries))
    } else {
      dispatch(fetchingCurrentUserProfileFailed(response.data));
    }
  } catch (error) {
    dispatch(fetchingCurrentUserProfileFailed(errorMessage));
  }
};

/*
 * Verify User Token Validity
 * */
// export const validateToken = () => async (dispatch, getState, api) => {
//   dispatch(validatingToken());
//   try {
//     let response = await api.get(API.checkJWT);

//     if (response.data.code === 200) {
//       dispatch(fetchUserPermissions());
//       return dispatch(validatingTokenSuccess(response.data.data));
//     }
//   await Cookies.remove("RE_BU_CR");
//     dispatch(validatingTokenFailed(response.data));
//   } catch (error) {
//     return dispatch(validatingTokenFailed(errorMessage));
//   }
// };

export const validateToken = () => async (dispatch, getState, api) => {
  dispatch(validatingToken());
  try {
    let response = await api.get(API.checkJWT);

    if (response.data.code === 200)
      return dispatch(validatingTokenSuccess(response.data.data));

    if (response.data.code === 401 || response.data.code === 402)
      return dispatch(generateToken());

    await Cookies.remove("RE_BU_CR");
    dispatch(validatingTokenFailed(response.data));
  } catch (error) {
    return dispatch(validatingTokenFailed(errorMessage));
  }
};

//****** Generate Token  ********//

export const generateToken = () => async (dispatch, getState, api) => {
  try {
    let existingRefreshToken = await getState().Auth.refreshToken;
    let guid = await getState().Auth.guid;

    let response = await api.post(API.generateNewToken, {
      refreshToken: existingRefreshToken,
      userId: guid,
    });

    if (response.data.code === 200) {
      let {
        data: {
          data: { accessToken, refreshToken },
        },
      } = response;

      await setAuthenticationCookie({
        accessToken,
        refreshToken,
        user: { guid },
      });
      return dispatch(generatingTokenSuccess(response.data.data));
    }

    await Cookies.remove("RE_BU_CR");

    return dispatch(generatingTokenFailed(response.data));
  } catch (error) {
    dispatch(generatingTokenFailed(error));
  }
};

//****** Logout  ********//

export const logoutUser = () => async (dispatch, getState, api) => {
  dispatch(loggingoutUser());
  try {
    let response = await api.post(API.logoutUser);
    if (response.data.code === 200) {
      await Cookies.remove("RE_BU_CR");
      return dispatch(loggingoutUserSuccess(response.data.data));
    }
    dispatch(loggingoutUserFailed(response.data));
  } catch (error) {
    dispatch(loggingoutUserFailed(errorMessage));
  }
};

//****** Reset Password   ********//

export const resetPassword = (payload) => async (dispatch, getState, api) => {
  dispatch(resettingPassword());
  const { accessToken } = await getAuthenticationCookie();
  axios
    .post(`${API.baseUrl}${API.changePassword}`, payload, {
      headers: {
        Authorization: accessToken,
        app_id: "1",
      },
    })
    .then((response) => {
      if (response.data.code === 200) {
        dispatch(resettingPasswordSuccess(response.data.data));
        toast.error(response.data.message);
      } else {
        dispatch(resettingPasswordFailed(response.data));
        toast.error(response.data.message);
      }
    })
    .catch((error) => {
      dispatch(resettingPasswordFailed(error));
      toast.error(errorMessage);
    });
};

//****** Forgot Password   ********//

export function forgotPassword(payload) {
  return async (dispatch, getState, api) => {
    dispatch(forgotpassword());
    try {
      let response = await api.get(`${API.forgotPassword}?username=${payload}`);
      if (response.data.code === 200) {
        dispatch(forgotPasswordSuccess(response.data.data));
        history.push("/auth/otp-verify");
        toast.error(response.data.message);
      } else {
        dispatch(forgotPasswordFailed(response.data));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(forgotPasswordFailed(errorMessage));
    }
  };
}

//****** OTP VARIFICATION   ********//

export function optVerification(payload) {
  return async (dispatch, getState, api) => {
    dispatch(otpverification());
    try {
      let response = await api.post(API.varifyOTP, payload);
      if (response.data.code === 200) {
        dispatch(otpverificationSuccess(response.data));
      } else {
        dispatch(otpverificationFailed(response.data));
      }
    } catch (error) {
      dispatch(otpverificationFailed(errorMessage));
    }
  };
}

//****** SET NEW PASSWORD   ********//

export function setNewPassword(payload) {
  return async (dispatch, getState, api) => {
    dispatch(settingNewPassword());
    try {
      let response = await api.post(API.setNewPassword, payload);
      if (response.data.code === 200) {
        dispatch(settingNewPasswordSuccess(response.data));
        history.push("/auth/login");
        toast.error(response.data.message);
      } else {
        dispatch(settingNewPasswordFailed(response.data));
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(settingNewPasswordFailed(errorMessage));
    }
  };
}

/**
 * encryption for login
 */
export const encryptString = async (string) => {
  try {
    let response = await axios.post(
      `${API.baseUrl}/auth/dashboard/encrypt`,
      { string }
    );
    if (response.data.code === 200) return response.data.data;
  } catch (error) {}
};
